var $4c8a5177cfbcc9e7$exports = {};
$4c8a5177cfbcc9e7$exports = {
    "valid": `Gyldig`
};


export {$4c8a5177cfbcc9e7$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
